import { Box } from '@material-ui/core';
import { GridPricing, Product } from '@setvi/shared/interfaces';
import { getGridProductDetailsPricing } from '../../../../../price/full/components/pricing/utils';

interface FullContentProps {
  product: Product;
  pricing: GridPricing[];
}
export const FullContent = ({ product, pricing }: FullContentProps) => (
  <Box
    style={{
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      rowGap: '8px'
    }}>
    {pricing.map(i => (
      <span
        key={i.label}
        style={{
          flex: '1 1 auto',
          display: 'flex',
          ...(i.fullWidth && { width: '100%' }),
          justifyContent: i.align || 'start'
        }}>
        {getGridProductDetailsPricing({ pricing: i, product })}
      </span>
    ))}
  </Box>
);
